module.exports = __webpack_public_path__ + "static/media/TelegrafoLogo.bf9a0bd6.jpeg";